<template>
    <div>
        <item-despesa
            :item="item"
            :temAcessoAlterarRateio="$temAcessoView('DESP-GERAIS-FINAL-05')"
            @obterUnidades="obterUnidades()"
            @obterProjetos="obterProjetos($event)"
            @obterAcoes="obterAcoes($event)"
            @salvarRateios="salvarRateios($event)"
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
        >
            <template slot="footer">
                <app-btn-voltar
                    rota="DespesasGerais_Finalizacao_Despesas_Detalhar"
                ></app-btn-voltar>
            </template>
        </item-despesa>
        <router-view></router-view>
    </div>
</template>

<script>
import ItemDespesa from '@/app/despesasgerais/componentes/itensDespesas/ItemDespesa.vue'
import ItensDespesasServicos from './ItensDespesasServicos'
import RateiosServicos from './../rateios/RateiosServicos'

export default {
    data() {
        return {
            item: {},
            unidades: [],
            projetos: [],
            acoes: []
        }
    },
    
    components: {
        ItemDespesa
    },

    methods: {
        obterItem() {
            if (this.$route.params.itemDespesa != null){
                this.item = this.$route.params.itemDespesa
            } else {
                this.$store.dispatch('addRequest')
                ItensDespesasServicos.obterPorId(this.$route.params.despesaItemId).then(response => {
                    if (response) {
                        if (response.success) {
                            this.item = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterUnidades() {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterUnidades().then(response => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterProjetos(evento) {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterProjetos(evento.codUnidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.projetos = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAcoes(evento){
            this.$store.dispatch('addRequest')
            RateiosServicos.obterAcoes(evento.codUnidade, evento.codProjeto).then(response => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        salvarRateios(rateiosEvent) {
            let rateiosDto = {
                rateios: rateiosEvent.rateios,
                justificativa: rateiosEvent.justificativa,
                despesaItemId: this.item.despesaItemId
            }
            this.$store.dispatch('addRequest')
            RateiosServicos.salvarRateios(rateiosDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Rateio atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterItem()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterItem()
    }
}

</script>